export const FILE_SIZE_WARNING_BYTES = 100 * 1024 * 1024; // 100 MB
export const FILE_SIZE_HARD_LIMIT_BYTES = 1024 * 1024 * 1024; // 1 GB

// Notification title and message strings (Download Collection ZIP in profile)
export const FILE_SIZE_HARD_LIMIT_TITLE = "File too large";
export const FILE_SIZE_HARD_LIMIT_MESSAGE =
  "ZIP is over 1 GB and cannot be downloaded. Use an S3 or cloud URI instead.";
export const FILE_SIZE_WARNING_TITLE = "Large download";
export const FILE_SIZE_WARNING_MESSAGE =
  "This ZIP is over 100 MB and may take a long time. Click again to download anyway.";

// Notification title and message strings (Verify → Collection → ZIP/CSV)
export const FILE_SIZE_VALIDATION_HARD_LIMIT_MESSAGE =
  "Files over 1 GB cannot be validated in the browser. Use an S3 or cloud URI instead.";
export const FILE_SIZE_VALIDATION_WARNING_TITLE = "Large file detected";
export const FILE_SIZE_VALIDATION_WARNING_MESSAGE =
  "Files over 100 MB may validate slowly. For collections above 1 GB, please use an S3 or cloud URI.";

// File preview
export const FILE_SIZE_PREVIEW_LIMIT_BYTES = 10 * 1024 * 1024; // 10 MB
export const FILE_SIZE_PREVIEW_TOO_LARGE_MESSAGE =
  "File too large. Preview unavailable.";
